namespace RioERP.Masters {
    export interface WhatsAppTemplateVariableMapForm {
        WhatsAppTemplateId: Serenity.IntegerEditor;
        WhatsAppTemplateVariableId: Serenity.IntegerEditor;
    }

    export class WhatsAppTemplateVariableMapForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.WhatsAppTemplateVariableMap';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WhatsAppTemplateVariableMapForm.init)  {
                WhatsAppTemplateVariableMapForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;

                Q.initFormType(WhatsAppTemplateVariableMapForm, [
                    'WhatsAppTemplateId', w0,
                    'WhatsAppTemplateVariableId', w0
                ]);
            }
        }
    }
}
